import { faCircleDollarToSlot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { QuerySkeleton } from '~/components/atoms/QuerySkeleton';
import { UpdateIapPollForm } from '~/components/forms/IapPollForm';
import { Breadcrumbs } from '~/components/molecules/Breadcrumbs';
import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';
import { useIapPollQuery } from '~/lib/api/modules/IapPolls/hooks/useIapPollQuery';

export type IAppUpdateIapPollPageProps = {
  appId: string;
  iapPollId: string;
  nextUrl?: string;
  cancelUrl?: string;
};

export const AppUpdateIapPollPage: React.FC<IAppUpdateIapPollPageProps> = (
  props,
) => {
  const { appId, iapPollId, nextUrl, cancelUrl } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const iapPollQuery = useIapPollQuery({
    appId,
    iapPollId,
  });

  const parentUrl = `/apps/${appId}/iapPolls`;

  return (
    <>
      <Helmet>
        <title>{t('AppUpdateIapPollPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId}>
        <Breadcrumbs.Action href={parentUrl}>
          <FontAwesomeIcon icon={faCircleDollarToSlot} />
          {t('AppIapPollsPage.title')}
        </Breadcrumbs.Action>
      </AppBreadcrumbs>

      <Heading
        title={
          <QuerySkeleton query={iapPollQuery} length={{ min: 8, max: 16 }}>
            {t('AppUpdateIapPollPage.title', {
              title: iapPollQuery.data?.title,
            })}
          </QuerySkeleton>
        }
        previousUrl={parentUrl}
      />

      <UpdateIapPollForm
        appId={appId}
        iapPollId={iapPollId}
        onSuccess={() => navigate(nextUrl ?? parentUrl)}
        cancelUrl={cancelUrl ?? parentUrl}
      />
    </>
  );
};
